import { render, staticRenderFns } from "./ReferenceValueToggle.vue?vue&type=template&id=56b05b20"
import script from "./ReferenceValueToggle.vue?vue&type=script&lang=js"
export * from "./ReferenceValueToggle.vue?vue&type=script&lang=js"
import style0 from "./ReferenceValueToggle.vue?vue&type=style&index=0&id=56b05b20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports